// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_hn-0";
export var optionCard = "_hn-1";